import { featuresModel } from 'APP/model/model';
import Entities from 'STORE';

export async function getE2eeIntegrationEnabled(): Promise<void> {
  let isE2eeIntegrationEnabled;
  try {
    isE2eeIntegrationEnabled = await featuresModel.getE2eeIntegrationEnabled();
  } catch {
    isE2eeIntegrationEnabled = false;
  }
  Entities.featuresStore.setIsE2eeIntegrationEnabled(isE2eeIntegrationEnabled);
}
